/**
 * @name ResponsibilitiesProgress
 * @description Componente de avance de responsabilidades para supervisores y tercer nivel en configuración de perfil
 * @author Ricardo Guerra
 */

import React, { PureComponent } from 'react';
import i18n from 'i18next';
import styled from 'styled-components';

import { EmployeeService } from '@services';
import { FiltersExpansion, Report } from '@components';
import { ResponsibilitiesService } from '@services';
import { MUI } from '@styles';

import { trackPromise } from 'react-promise-tracker';

class ResponsibilitiesProgress extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reportConfig: {
        rows: [],
        columns: [
          { id: 'Nombre', label: i18n.t('GenericMessages.name'), visible: true },
          { id: 'Porcentaje', label: i18n.t('GenericMessages.percentage'), visible: true },
          { id: 'Estatus', label: i18n.t('GenericMessages.status'), visible: true }
        ]
      },
      structure: [],
      filters: {
        employee: null,
        status: 0
      },
    };
  }

  componentDidMount() {
    const { filters } = this.state;
    this.getReport(filters);
    this.getStructure();
  }

  /**
   * Consulta la estructura del supervisor o tercer nivel
   */
  getStructure = () => {
    const configFilter = {
      tipoEstructura: true,
      estructuraDirecta: true
    };

    EmployeeService.getStructure({ page: 0, size: 0, filter: configFilter })
      .then((response) => {
        this.setState({ structure: response });
      })
      .catch(() => { });
  }

  /** 
   * Actualiza los filtros del reporte
   * @param filters (employee, status)
   */
  updateFilters = ({ employee, status }) => {
    const filters = {
      employee: employee ? employee.IdEmpleado : null,
      status: status !== 0 ? status : null
    };

    this.getReport(filters);
    this.setState({ filters: { employee, status } });
  }

  getReport = (filters) => {
    trackPromise(
      ResponsibilitiesService.getStructureReport({
        page: 0,
        size: 0,
        filter: {
          IdEmpleado: filters.employee,
          Id: filters.status
        }
      })
        .then((response) => {
          const { reportConfig } = this.state;
          reportConfig.rows = response;
          this.setState(({ reportConfig }) => ({
            reportConfig: {
              ...reportConfig,
              rows: response
            }
          }));
        })
        .catch(() => {
          // No encuentra registros (Error 404).
          this.setState(({ reportConfig }) => ({
            reportConfig: {
              ...reportConfig,
              rows: []
            }
          }));
        }),
      'loading-report'
    );
  }

  render() {
    const {
      filters,
      reportConfig,
      structure
    } = this.state;

    return (
      <>
        {/* Filtros */}
        <FiltersExpansion>
          <MUI.Grid container>
            {/* Empleado */}
            <MUI.Grid item md={3} sm={6} xs={12}>
              <Styled.BoxFilter>
                <MUI.Autocomplete
                  label={i18n.t('GenericMessages.employee')}
                  searchList={structure}
                  searchBy="Nombre"
                  value={filters.employee}
                  onChange={(newEmployee) => this.updateFilters({
                    employee: newEmployee,
                    status: filters.status
                  })}
                />
              </Styled.BoxFilter>
            </MUI.Grid>
            {/* Estatus */}
            <MUI.Grid item md={3} sm={6} xs={12}>
              <Styled.BoxFilter>
                <MUI.TextField
                  select
                  label={i18n.t('GenericMessages.status')}
                  type="text"
                  name="status"
                  value={filters.status}
                  onChange={(event) => this.updateFilters({
                    employee: filters.employee,
                    status: event.target.value
                  })}
                >
                  <MUI.SelectOption value={0}>
                    {i18n.t('GenericMessages.all')}
                  </MUI.SelectOption>
                  <MUI.SelectOption value={1}>
                    {i18n.t('StatusText.active')}
                  </MUI.SelectOption>
                  <MUI.SelectOption value={2}>
                    {i18n.t('StatusText.toBeApproved')}
                  </MUI.SelectOption>
                  <MUI.SelectOption value={3}>
                    {i18n.t('StatusText.approved')}
                  </MUI.SelectOption>
                  <MUI.SelectOption value={4}>
                    {i18n.t('StatusText.rejected')}
                  </MUI.SelectOption>
                </MUI.TextField>
              </Styled.BoxFilter>
            </MUI.Grid>
          </MUI.Grid>
        </FiltersExpansion>
        {/* Reporte */}
        <MUI.Box padding="8px">
          <Report
            columns={reportConfig.columns}
            rows={reportConfig.rows}
            exportToCSV={true}
            exportFileName={i18n.t('GenericMessages.responsibilities')}
          />
        </MUI.Box>
      </>
    );
  }
}

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxFilter = styled.div`
  padding: 8px;
`;

export default ResponsibilitiesProgress;